module.exports = __webpack_public_path__ + "static/hrmos-8364bdfe918184c79fe87a431d87f866.jpg";